// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__2fP2C","booksList":"Home_booksList__3zL3s","noResult":"Home_noResult__3ix2N","loader":"Home_loader__nMjl7"};